import { ToastAndroid } from "react-native";
import metrics from "@constants/metrics";

const xOffset = 0;
const yOffset = metrics.screenWidth;

const showShortToast = (msg) =>
  ToastAndroid.showWithGravityAndOffset(
    msg,
    ToastAndroid.SHORT,
    ToastAndroid.BOTTOM,
    xOffset,
    yOffset,
  );

const showLongToast = (msg) =>
  ToastAndroid.showWithGravityAndOffset(
    msg,
    ToastAndroid.LONG,
    ToastAndroid.BOTTOM,
    xOffset,
    yOffset,
  );

export default {
  showShortToast,
  showLongToast,
};
